<template>
  <b-card no-body>
	  
	<div class="m-2">
	
	  <b-row>
	
		<!-- 添加用户组 -->
	    <b-col
	      cols="12"
	      md="6"
	      class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
	    >
	      <b-button
	          variant="primary"
	          :to="{ name: 'users-group-add'}"
	      >
	        {{$t('Add Group')}}
	      </b-button>
	    </b-col>
	
	   
	  </b-row>
	
	</div>
	
	
	<b-table
	  :items="groups"
	  responsive
	  :fields="columns"
	  show-empty
	  :empty-text="$t('No matching records found')"
	  class="position-relative"
	  sort-icon-left
	  @sort-changed="handleSortChange"
	>
	   
	
	  <!-- 列: Actions -->
	  <template #cell(actions)="data">
	
	    <div class="text-nowrap">
			
			<a
			@click="$router.push({ name: 'users-group-edit', params: { name: data.item.groupName }})"
			>
			  <feather-icon
			  icon="EditIcon" />
			  <span class="align-middle ml-50">{{$t("Edit")}}</span>	
			</a>
			
			<a @click="onClickDel(data.index, data.item.groupName)" >
				<feather-icon class="ml-2" icon="TrashIcon" />
				<span class="align-middle ml-50">{{$t("Delete")}}</span>
			</a>
	
	    </div>
	  </template>
	
	</b-table>
	
	
	<div class="mx-2 mb-2">
	    <b-row>
	      <!-- 页码 -->
	      <b-col
	        cols="12"
	        sm="12"
	        class="d-flex align-items-center justify-content-center justify-content-sm-start"
	      >
	
	        <b-pagination
	          v-model="filter.Page"
	          :total-rows="total"
	          :per-page="filter.Size"
	          first-number
	          last-number
	          class="mb-0 mt-1 mt-sm-0"
	          prev-class="prev-item"
	          next-class="next-item"
			  @change="onClickPage"
	        >
	          <template #prev-text>
	            <feather-icon
	              icon="ChevronLeftIcon"
	              size="18"
	            />
	          </template>
	          <template #next-text>
	            <feather-icon
	              icon="ChevronRightIcon"
	              size="18"
	            />
	          </template>
	        </b-pagination>
	
	      </b-col>
	
	    </b-row>
	</div>
	


  </b-card>
</template>

<script>
import {
  BCard, BTable, BLink, BDropdown, BDropdownItem, BTooltip, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getDeviceStatus,getOnlineDevices,getOfflineDevices } from '@/api/device'
import { getGroups, delGroup } from '@/api/user'

export default {
  components: {
    BCard,
	BTable,
	BLink,
	BDropdown,
	BDropdownItem,
	BTooltip,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    ToastificationContent,
	vSelect,
  },
  data() {
    return {
	  //总数
	  total:0,
      //用户组列表
      groups:[],
      //列表筛选参数
      filter:{
        Page:1,
        Size:20,
      },
	  //表格字段结构
      columns: [
		{ key: 'groupName', label: this.$t('Group Name'), sortable: true},
		{ key: 'groupDescription', label: this.$t('Group Description'), sortable: true},
		{ key: 'actions', label: this.$t('Actions') },
      ],
    }
  },
  created() {
    this.getGroups()
  },
  methods: {
    //获取用户组列表
    getGroups(){
      getGroups(this.filter).then(response => { 
		this.groups = response.data
		this.total = response.count
      })
    },
	//点击分页
	onClickPage(page){
	  this.filter.Page = page
	  this.getGroups()
	},
	//删除用户组
	onClickDel(index, name){
		
		this.$bvModal
		  .msgBoxConfirm(this.$t('Please confirm will delete?'), {
		    size: 'sm',
		    okVariant: 'primary',
		    okTitle: this.$t('Confirm'),
		    cancelTitle: this.$t('Cancel'),
		    cancelVariant: 'outline-secondary',
		    hideHeaderClose: false,
		    centered: true,
		  })
		  .then(value => {
		    if(value){
				this.groups.splice(index, 1)
				delGroup(name).then(response => {
                  this.$toast.success(this.$t('Delete Success'))
                })
			}
		  })
		  
	},
	//排序
	handleSortChange(e){
	  this.filter.PropertyName = e.sortBy
	  this.filter.IsDesc = e.sortDesc
	  this.groups = []
	  this.getGroups()
	},
  }
}
</script>
<style lang="scss" scoped>

.filter-select {
  min-width: 290px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 200px;
  }
}
</style>
